import { Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Catagories } from '../util/HardCodedLists';
import { useSnackbar } from 'notistack';
import ChipBowl from '../components/ChipBowl'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    input: {
        marginTop: '20px',
    },
}));

const QuickEdit = (props: editProps) => {
    const classes = useStyles();
    const { register, getValues, errors } = useForm({ mode: 'onChange', shouldUnregister: false });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [cat, setCat] = React.useState(props.model.Category ? Catagories.findIndex((e) => e === props.model.Category) : '');

    function OnChange() {
        let data = getValues();
        data.Tags = chipData;
        data.Category = cat;
        data.PublicID = props.model.PublicID,
            props.editCB(props.modelIndex, data);
    }

    const maxTagLength = 20;
    const alphaNumeric = /^[\w\-\s]+$/;
    const [chipData, setChipData] = React.useState(props.model.Tags.map((tag) => { return { key: Math.random(), label: tag } }));
    const handleChipInput = (event) => {
        if (!event.key.match(alphaNumeric)) {
            event.preventDefault();
        }

        if (event.key === 'Enter' && chipData.length < 8 && event.target.value.length >= 2) {
            setChipData([...chipData, { key: Math.random(), label: event.target.value }]);
            event.target.value = "";
        }
        else if (event.key === 'Enter' && chipData.length >= 8) {
            enqueueSnackbar("Too many tags! Try removing one", {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            });
        }

        if (event.target.value.length > maxTagLength) {
            event.preventDefault();
            event.target.value = event.target.value.slice(0, maxTagLength + 1);
        }
    }

    //on change for chips + category since they're driven by state
    React.useEffect(() => { OnChange() }, [chipData, cat])

    return (
        <React.Fragment>
            <TextField
                label="Title"
                name="Title"
                className={classes.input}
                fullWidth
                variant="outlined"
                defaultValue={props.model.Title}
                onChange={OnChange}
                error={errors.Title !== undefined}
                helperText={errors.Title?.message}
                disabled={!props.editable}
                inputRef={register({
                    required: 'Required', maxLength: {
                        value: 30,
                        message: `Title is too long`
                    }
                })}
            />

            <TextField
                className={classes.input}
                onChange={OnChange}
                label="Description"
                name="Description"
                placeholder="Describe the model"
                fullWidth
                multiline
                variant="outlined"
                //onChange={(e) => setModelDesc(e.target.value)}
                disabled={!props.editable}
                defaultValue={props.model.Description}
                minRows={4}
                maxRows={12}
                error={errors.Description !== undefined}
                helperText={errors.Description?.message}
                inputRef={register({
                    maxLength: {
                        value: 300,
                        message: `Description is too long`
                    }
                })}
            />

            <FormControl
                className={classes.input}
                fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                    MenuProps={{ disableScrollLock: true }}
                    disabled={!props.editable}
                    placeholder="Category"
                    name="Category"
                    id="catInput"
                    label="Category"
                    onChange={(e) => { setCat(e.target.value) }}
                    fullWidth
                    error={errors.Category !== undefined}
                    defaultValue={props.model.Category}
                    value={cat}
                //helperText={errors.Category?.message}
                //inputRef={register({ required: 'Required' })}
                >
                    {Catagories.map((item, index) => {
                        if (item === 'Other') index = 999;
                        return <MenuItem key={index} value={index}>{item}</MenuItem>
                    })}
                </Select>
            </FormControl>

            {props.editable && <TextField
                className={classes.input}
                label="Add a search tag"
                fullWidth
                helperText="Title and tags are used for search, so try to include words that you might use when searching for this model"
                onKeyPress={handleChipInput}
            />}

            <ChipBowl className={classes.input} chips={chipData} setChips={setChipData} disabled={!props.editable} />

            <FormGroup>
                <FormControlLabel control={
                    <Checkbox
                        color="primary"
                        checked={props.SelectedModel}
                        onClick={() => props.ChangeSelected()}
                    />}
                    label="Featured"
                />
            </FormGroup>

        </React.Fragment>
    );
}

interface editProps {
    model: { Category: string; PublicID: string; Tags: any[]; Title: string; Description: string; };
    editCB: (arg0: any, arg1: { [x: string]: any; }) => any;
    modelIndex: any;
    editable: boolean;
    SelectedModel: boolean;
    ChangeSelected(): void;
}

export default QuickEdit;